import { useTheme } from '@mui/material';
import { html } from 'diff2html';
import { FC, useEffect, useState } from 'react';
import 'highlight.js/styles/dark.css';
import 'diff2html/bundles/css/diff2html.min.css';
import convertHtmlToReact from '@hedgedoc/html-to-react';
import { ThemeProvider } from '@mui/material';
import { lightTheme } from '../../common/themes';
import { makeStyles } from 'tss-react/mui';

const SyntaxCodeDiffHighlighter: FC<SyntaxCodeDiffHighlighterProps> = ({
  fileDiff,
}) => {
  const theme = useTheme();
  const [diff, setDiff] = useState('');
  const { classes, cx } = useStyles();
  useEffect(() => {
    var diffHtml = html(fileDiff, {
      drawFileList: false,
      outputFormat: 'side-by-side',
    });
    setDiff(diffHtml);
  }, [fileDiff]);
  return (
    <ThemeProvider theme={lightTheme}>
      <div
        className={cx(theme.palette.mode === 'dark' && classes.darkDiff)}
        style={{ width: '100%' }}
        id='code-diff'>
        {convertHtmlToReact(diff)}
      </div>
    </ThemeProvider>
  );
};
const useStyles = makeStyles()({
  darkDiff: {
    '& .d2h-ins': {
      backgroundColor: '#b4e2b4',
      color: 'black',
    },
    '& .d2h-change': {
      color: 'black',
    },
    '& .d2h-info, .d2h-code-side-linenumber': {
      backgroundColor: '#0f1321',
      color: 'white',
    },
    '& .d2h-file-wrapper': {
      border: '1px solid #FFF',
    },
    '& .d2h-file-header, .d2h-tag': {
      backgroundColor: '#0f1321',
    },
    '& .d2h-del': {
      backgroundColor: '#fbb9bc',
    },
    '&  .d2h-code-side-line del': {
      backgroundColor: '#f6666d',
    },
    '& .d2h-code-side-emptyplaceholder, .d2h-emptyplaceholder': {
      backgroundColor: '#5e5e5e',
    },
  },
});

export interface SyntaxCodeDiffHighlighterProps {
  fileDiff: string;
}

export default SyntaxCodeDiffHighlighter;
